import React from "react"
import PropTypes from "prop-types"

import Dot from "react-icons/lib/md/fiber-manual-record"
import Check from "react-icons/lib/md/check-circle"
import Error from "react-icons/lib/md/clear"

import withStyles from "@material-ui/core/styles/withStyles"

import { Typography } from "@material-ui/core"

import styles from "./styles"

const CheckWithText = ({
    classes,
    isValid,
    text,
    textVariant,
    iconSize,
    error,
}) => {
    const getIcon = () => {
        if (isValid) {
            return <Check size={iconSize} className={classes.checkCircle} />
        }
        if (error) {
            return <Error size={iconSize} className={classes.error} />
        }
        return <Dot size={iconSize} className={classes.dot} />
    }
    return (
        <div className={classes.root}>
            {getIcon()}
            {text && (
                <Typography variant={textVariant} className={classes.text}>
                    {text}
                </Typography>
            )}
        </div>
    )
}

CheckWithText.propTypes = {
    classes: PropTypes.object.isRequired,
    isValid: PropTypes.bool,
    text: PropTypes.string,
    textVariant: PropTypes.string,
    iconSize: PropTypes.number,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

CheckWithText.defaultProps = {
    isValid: false,
    text: null,
    textVariant: "caption",
    iconSize: 12,
    error: false,
}

export default withStyles(styles)(CheckWithText)
